module.exports = __webpack_public_path__ + "images/traffic-cone.ee6f2826da8c61448c74b3f760881875.png";